// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file feedback_settings.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file feedback_settings.proto.
 */
export const file_feedback_settings: GenFile = /*@__PURE__*/
  fileDesc("ChdmZWVkYmFja19zZXR0aW5ncy5wcm90bxILZ3JwYy5hcGkudjEiaAoQRmVlZGJhY2tTZXR0aW5ncxIPCgdlbmFibGVkGAIgASgIEhoKDXVzZV9icmVha2Rvd24YAyABKAhIAIgBARIVCg1ub19ydWxlX2Vycm9yGAQgASgIQhAKDl91c2VfYnJlYWtkb3duQgZaBC47cGJiBnByb3RvMw");

/**
 * FeedbackSettings
 *
 * @generated from message grpc.api.v1.FeedbackSettings
 */
export type FeedbackSettings = Message<"grpc.api.v1.FeedbackSettings"> & {
  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: optional bool use_breakdown = 3;
   */
  useBreakdown?: boolean | undefined;

  /**
   * @generated from field: bool no_rule_error = 4;
   */
  noRuleError: boolean;
};

/**
 * Describes the message grpc.api.v1.FeedbackSettings.
 * Use `create(FeedbackSettingsSchema)` to create a new message.
 */
export const FeedbackSettingsSchema: GenMessage<FeedbackSettings> = /*@__PURE__*/
  messageDesc(file_feedback_settings, 0);

